/*微信小程序配置*/
const wxminiCfg = {
    //云卡维修连锁
    newClient:{
    	appId: 'wx9ed82a18f13f2603'
    }
}

export{
    wxminiCfg
}
